import { UserProfile } from "../../models/UserProfile";

export const getUserByFullname = (users: UserProfile[]) => (fullName: string): UserProfile | undefined => {
    return users.find(x => `${x.firstname} ${x.lastname}` === fullName)
}